import * as Yup from 'yup'
import FormBuilder, { FormFields } from "app/modules/tp/builders/FormBuilder";
import { Referent } from "../_models";
import { Provider } from '../../providers/_models';
import ProviderAPI from '../../providers/_requests';

const generateFormFields = async () => {

    const response = await ProviderAPI.getAllNoPagination({});
    let providers: Array<Provider> = [];

    if (response?.success) {
        providers = response.data as Array<Provider>;
    }

    const formFields: FormFields<Referent> = {
        title0: {
            type: "titleView",
            title: "Info",
            icon: <i className="fa-solid fa-user-tie"></i>
        },
        id: {
            type: "text",
            key: "id",
            label: "# ID",
            attributes: {
                disabled: true
            },
            validation: Yup.number().integer().nullable(),
        },
        providers: {
            type: "select",
            key: "providers",
            label: "Fornitore",
            isMulti: true,
            options: providers.map(provider => ({ value: (provider.id?.toString()), label: `${provider.name?? ""} ${provider. surname ??""}` })),
        },
        name: {
            type: "text",
            key: "name",
            label: "Nome",
            validation: Yup.string()
                .max(50, 'Il nome visualizzato deve essere di massimo 50 caratteri')
                .nullable(),
        },
        surname: {
            type: "text",
            key: "surname",
            label: "Cognome",
            validation: Yup.string().nullable()
                .max(50, 'Il cognome deve essere di massimo 50 caratteri')
                .nullable(),
        },
        phone: {
            type: "text",
            key: "phone",
            label: "Telefono",
            validation: Yup.string().nullable()
                .min(10, 'Il telefono deve avere almeno 10 caratteri')
                .max(11, 'Il telefono deve avere al massimo 11 caratteri')
                .matches(/^(\+)?[0-9]+$/, 'Il telefono deve essere valido'),
        },
        email: {
            type: "text",
            key: "email",
            label: "Email",
            validation: Yup.string().nullable()
                .max(50, 'L\'email deve essere di massimo 50 caratteri')
                .required('L\'email è obbligatoria')
                .email('L\'email deve essere valida'),
        },
    }
    return formFields;
}

const ReferentFormBuilder = async () => {
    const formFields = await generateFormFields();
    return FormBuilder<Referent>({ formFields })
}

export default ReferentFormBuilder;
